import { getCookie, setCookie } from '../cookies';
import { toggleTheme } from '../theme-toggle';
import { togglePresentationMode } from '../cursor';
import { toggleLineType } from '../line-type';
import { toggleVerticalGridLines } from '../vertical-grid-lines';
import { updateLineStyle } from '../line-style';
import { toggleRegionalStatisticsSingleModelColor } from '../charts/regional-statistics-single-model';
import { ts } from '../../modules/main';

// import interfaces
import { Aeroval } from '../../types/global';
import { CanvasConfig } from '../../types/config';
declare var aeroval: Aeroval;

import canvasConfig from '../../../public/config/canvas.json';

import './style.css'

type LineStyle = 'lineWidthFactor' | 'markerEnabledThreshold' | 'markerSize';

export function offCanvas(keys: [keyof CanvasConfig]) {
	fillOutOffCanvasContent(canvasConfig, keys);
}

function fillOutOffCanvasContent(data: CanvasConfig, keys: [keyof CanvasConfig]) {
	const offCanvasHeader = `<div class="offcanvas offcanvas-end bg-light bg-opacity-75" tabindex="-1" id="offcanvas-settings" aria-labelledby="offcanvas-settings-label">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvas-settings-label">
                <i class="fas fa-gear"></i>
                Users Settings
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>`;

	var offCanvasBody = `<div class="offcanvas-body p-4">`;
	for (let key of keys) {
		if (data[key].enabled === false) continue;

		offCanvasBody += `<h6 class="offcanvas-title" id="offcanvas-settings-label" title="${data[key].description}">${data[key].title}</h6>`

		if (data[key].type === 'radio') {
			offCanvasBody += `<div class="btn-group" role="group" aria-label="Basic radio toggle button group">`;
			for (let option of data[key].options) {
				offCanvasBody += `<input type="radio" class="btn-check" name="btn-radio-${key}" id="btn-radio-${key}-${option.value}" autocomplete="off">
					<label class="btn btn-light" for="btn-radio-${key}-${option.value}" value="${option.value}">${option.title}</label>`;
			}
			offCanvasBody += `</div>`;
		} else if (data[key].type === 'range') {
			offCanvasBody += `<div style="display: inline-flex; align-items: center;">
				<input type="range" id="range-${key}" name="range-${key}" min="${data[key].options[0].value}" max="${data[key].options[1].value}" step="${data[key].options[2].value}" value="${data[key].default}" oninput="document.getElementById('range-${key}-output').value = this.value">
				<output id="range-${key}-output" class="mx-3">${data[key].default} (default: ${data[key].default})</output>
			</div>`;
		}
	}
	offCanvasBody += `</div>`;

	const canvasContent = document.querySelector('#offcanvas-content');
	if (canvasContent instanceof HTMLElement) {
		canvasContent.innerHTML = offCanvasHeader + offCanvasBody;
	}

	// add checked attribute to default option
	for (const key of keys) {
		// check cookies
		const defaultOption = getCookie(key as string) ? getCookie(key as string) : data[key as string].default;

		if (data[key].type === 'radio') {
			const defaultElement = document.querySelector(`#btn-radio-${key as string}-${defaultOption}`);
			if (defaultElement instanceof HTMLInputElement) {
				defaultElement.checked = true;
				if (key === 'theme') {
					toggleTheme(defaultOption);
				}
				if (key === 'presentationMode') {
					togglePresentationMode(defaultOption);
				}
				if (key === 'lineStyle') {
					toggleLineType(defaultOption);
				}
				if (key === 'verticalGridLines') {
					toggleVerticalGridLines(defaultOption);
				}
			}
		} else if (data[key].type === 'range') {
			const rangeElement = document.querySelector(`input[id=range-${key}]`)
			if (rangeElement as HTMLInputElement) {
				(rangeElement as any).value = defaultOption
			}
			const rangeOutputElement = document.querySelector(`#range-${key}-output`)
			if (rangeOutputElement as HTMLInputElement) {
				(rangeOutputElement as any).innerHTML = defaultOption
			}

			if (key === 'lineWidthFactor' || key === 'markerEnabledThreshold') {
				updateLineStyle(key, defaultOption);
			}
		}
		// set aeroval settings
		aeroval.settings[key] = defaultOption;

	}
	// add events
	for (const key of keys) {
		// radio buttons
		document.querySelectorAll(`input[name=btn-radio-${key}]`).forEach((element) => {
			element.addEventListener('change', function (event) {
				const inputElement = event.target as HTMLInputElement;
				const value = inputElement.id.split(`btn-radio-${key}-`)[1];
				aeroval.settings[key] = value;
				setCookie(key as string, value, 365);

				if (key === 'presentationMode') {
					togglePresentationMode(value);
				}
				if (key === 'lineType') {
					toggleLineType(value);
				}
				if (key === 'verticalGridLines') {
					toggleVerticalGridLines(value);
				}
				if (key === 'regionalStatisticsSingleModelColor') {
					toggleRegionalStatisticsSingleModelColor(value);
				}
				if (key === 'showEmptyRegions') {
					location.reload();
				}
				if (key === 'showProxyVariables') {
					ts(true, true);
				}
			});
		});

		// ranges
		const rangeElement = document.querySelector(`input[id=range-${key}]`)
		if (rangeElement as HTMLInputElement) {
			rangeElement?.addEventListener('change', function (event) {
				const value = (event.target as any).value;
				setCookie(key as string, value, 365);
				updateLineStyle(key as LineStyle, value);
			})
		}
	}
}
